var tabs = document.querySelectorAll("info-tabs--vertical .js-info-tab");
var panels = document.querySelectorAll("info-tabs--vertical .js-info-panel");
function reset() {
  tabs.forEach(tab => {
    if(tab.classList.contains("active")) tab.classList.remove("active");
  })
  
  panels.forEach(panel => {
    if(panel.classList.contains("active")) panel.classList.remove("active");
  })
}

tabs.forEach(tab => {
  tab.addEventListener("click", (e) => {
    if (!e.currentTarget.classList.contains("active")) {
      reset();
      var panelID = e.currentTarget.getAttribute("rel");
      var panel = document.getElementById(`panel-${panelID}`);

      e.currentTarget.classList.add("active");

      panel.classList.add("active");
    }
  })
});



document.addEventListener("DOMContentLoaded", function () {
  const openBtn = document.getElementById("openBtn__info");
  const closeBtn = document.getElementById("closeBtn__info");
  const sideDrawer = document.getElementById("side--drawer__info");
  // Check if overlay already exists
  let overlay = document.querySelector(".overlay");

  if (!overlay) {
    overlay = document.createElement("div");
    overlay.className = "overlay";
    document.body.appendChild(overlay);
  }

  if (openBtn) {
    openBtn.addEventListener("click", () => {
      sideDrawer.style.right = "0";
      overlay.style.display = "block";
      document.body.classList.add("no-scroll");
    });
  }

  function closeSideBar() {
    sideDrawer.style.right = "-100%";
    overlay.style.display = "none";
    document.body.classList.remove("no-scroll");
  }

  if (closeBtn) {
    closeBtn.addEventListener("click", (event) => {
      event.preventDefault();
      closeSideBar();
    });
  }

  if (overlay) {
    overlay.addEventListener("click", (event) => {
      if (event.target === overlay) {
        closeSideBar();
      }
    });
  }

  if (sideDrawer) {
    window.addEventListener("resize", function () {
      if (window.innerWidth < 767) {
        sideDrawer.style.width = "100%";
      } else {
        sideDrawer.style.width = "60%";
      }
    });
  }
});
